import { TagInfo, RadioVal } from './vo/tag-info.model';
/**
 * タグ集約画面の値を管理するクラス
 *
 * @export KYMW4601Model
 * @class KYMW4601Model
 */
export class KYMW4601Model {
  public static readonly RADIO_VAL_TRUE: RadioVal = '1';
  public static readonly RADIO_VAL_FALSE: RadioVal = '';

  // タグ一覧
  public tagList: TagInfo[] = [];

  // 集約先タグ
  get aggregationTagId(): string {
    return (
      this.tagList.find(_t => _t.radioVal === KYMW4601Model.RADIO_VAL_TRUE)
        ?.tagId ?? ''
    );
  }

  /**
   * 集約先タグ名
   *
   * @memberof KYMW4601Model
   */
  get aggregationTagName(): string {
    return (
      this.tagList.find(_t => _t.radioVal === KYMW4601Model.RADIO_VAL_TRUE)
        .tagName ?? ''
    );
  }

  /**
   * 集約対象タグ
   *
   * @memberof KYMW4601Model
   */
  get targetTagIds(): string[] {
    return this.tagList
      .filter(_t => _t.radioVal === KYMW4601Model.RADIO_VAL_FALSE)
      .map(_t => _t.tagId);
  }
}
